<div class="dialog-content">
    <h6 class="dialog-main-title">Need More Time?</h6>
    <hr class="title-line mt-1 mb-2">
    <p>
        Your session is about to expire. You will be automatically signed out in
    </p>
    <h6 class="time-display"><span>{{currentValue}}</span></h6>
    <p>
        To continue your session, select <strong>Stay Signed In</strong>.
    </p>
    <div class="dialog-actions">
        <div class="col-12">
            <div class="row">
                <div class="col-6">
                </div>
                <div class="col-6 text-end">
                    <button (click)="closeDialog(true)" appearance="primary" tuiButton size="s" type="button"
                        class="tui-space_bottom-3" tuiAutoFocus>
                        Stay Signed In
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>